module.exports = __webpack_public_path__ + "static/media/country_vu.18dd218e.webp";